export default "__VITE_ASSET__29451dc9__"